module.exports = __webpack_public_path__ + "static/img/viral_08.66faff1c.jpg";